<template>
  <div id="main-container">
    <main-header />
    <main-sidebar />
    <div class="body">
      <router-view />
    </div>
  </div>
</template>

<script>
import MainHeader from "@/components/MainHeader";
import MainSidebar from "@/components/MainSidebar";
export default {
  name: "Container",
  components: { MainSidebar, MainHeader },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/app-variables";

#main-container {
  height: 100%;
  width: 100%;
  position: relative;
  & > .main-header {
    position: absolute;
    top: 0;
    left: $--app-sidebar-width-expanded;
    right: 0;
    height: $--app-header-height;
  }
  & > .main-sidebar {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: $--app-sidebar-width-expanded;
  }
  & > .body {
    position: absolute;
    top: $--app-header-height;
    left: $--app-sidebar-width-expanded;
    right: 0;
    bottom: 0;
    & > .view-container {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
